import { STORAGE_KEYS } from '../constants';

const readJson = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || null;
  } catch (error) {
    console.error(`Error parsing ${key} from localStorage:`, error);
    return null;
  }
};

const writeJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error saving ${key} to localStorage:`, error);
  }
};

/**
 * Last-used filters. The URL is the source of truth for the current view;
 * this is only the seed used when the URL carries no filters at all.
 */
export const getSavedFilters = () => readJson(STORAGE_KEYS.FILTERS);

export const saveFilters = (filters) => writeJson(STORAGE_KEYS.FILTERS, filters);

export const getSavedUi = () => readJson(STORAGE_KEYS.UI);

export const saveUi = (ui) => writeJson(STORAGE_KEYS.UI, ui);
